import { Fetch, schemas } from '@convergence/client';
import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { fetch } from '../fetch';

export function launchTinkerBox(fetch: Fetch) {
  return fetch(
    '/tinker-boxes',
    { method: 'POST' },
    schemas.LaunchTinkerBoxResponse
  );
}

export function useLaunchTinkerBoxMutation() {
  const m = useMutation({
    retry: false,
    mutationFn: () => launchTinkerBox(fetch),
    mutationKey: ['launchTinkerBox']
  });

  useEffect(() => {
    if (m.error) {
      try {
        const parsed = JSON.parse(m.error.message);
        const message = parsed.message;
        toast.error(message);
      } catch (e) {
        toast.error('Unable to launch TinkerBox');
      }
    }
  }, [m.error]);

  return { ...m, launchTinkerBox: m.mutateAsync };
}
